// src/components/SuperviseurEnChefLayout.js

import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import NotificationCenter from './NotificationCenter';
import './SuperviseurEnChefLayout.css';

function SuperviseurEnChefLayout({ onLogout }) {
  return (
    <div className="superviseur-en-chef-layout">
      {/* Menu latéral pour le superviseur en chef */}
      <nav className="superviseur-en-chef-sidebar">
        <div className="sidebar-header">
          <h3>Portail Superviseur en Chef</h3>
        </div>
        <ul className="nav-list">
          {/* Les liens spécifiques au superviseur en chef */}
          <NavLink to="/superviseur-en-chef/dashboard">Tableau de Bord</NavLink>
          <NavLink to="/superviseur-en-chef/validations">À Valider</NavLink>
          <NavLink to="/superviseur-en-chef/validees">Rapports Validés</NavLink>
          <NavLink to="/superviseur-en-chef/rejetes">Rapports Rejetés</NavLink>
          <NavLink to="/superviseur-en-chef/export">Exporter Excel</NavLink>
        </ul>
        <button onClick={onLogout} className="sidebar-logout-button">Déconnexion</button>
      </nav>

      {/* Le contenu de la page s'affichera ici */}
      <main className="superviseur-en-chef-content">
        {/* Barre de navigation supérieure avec notifications */}
        <div className="top-navbar">
          <div className="navbar-spacer"></div>
          <NotificationCenter />
        </div>
        <Outlet />
      </main>
    </div>
  );
}

export default SuperviseurEnChefLayout;
